import { render, staticRenderFns } from "./preferences.vue?vue&type=template&id=81e88278&scoped=true"
import script from "./preferences.vue?vue&type=script&lang=js"
export * from "./preferences.vue?vue&type=script&lang=js"
import style0 from "./preferences.vue?vue&type=style&index=0&id=81e88278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e88278",
  null
  
)

export default component.exports